import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import Autoload from '../../../../neoverv/Autoload';
import { browserName } from "react-device-detect";

import $ from 'jquery';
import {
  Table, 
  TableBody, 
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core';
import { showNotification } from '@mantine/notifications';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import EmptyIcon from '../../../../assets/images/EmptyReciept.svg';
import Bank from '../../../../assets/images/module/general/Bank.svg';
import { formatNumber } from '../../../../helpers/stringsManipulations';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import dayjs from 'dayjs';
import imageCompression from 'browser-image-compression';
import accounting from 'accounting';
import GlobalServices from '../../../../neoverv/helpers/services/GlobalServices';

import {
  setSelectedTaxYearForTaxDeclaration
} from '../../../../redux/action/General/generalActions';
import { EmptyStateContainer } from '../../../../neoverv';

var Setting = Autoload.Setting;
const { loader, checkEnvironment, errorHandlingForPDF } = Autoload.MainHelper;
const ref = React.createRef();

const Logo = "data:image/svg+xml;base64,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";
const EmptyStateIcon= "data:image/svg+xml;base64,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";

export class TransactionsPdfExport extends Component {
  static propTypes = {
    prop: PropTypes,
  };

  tableHeadCellStyling = {
    color: 'rgb(114, 114, 147)',
    padding: '1mm',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    margin: '0px',
    fontSize: '7pt',
    lineHeight: '20px',
    border: '1px solid #DADAE6',
    height: '0px',
    textAlign: 'left',
    minWidth: '12.5%',
  }

  tableBodyCellStyling = {
    color: '#0e0e1d',
    padding: '1mm',
    fontWeight: '400',
    //whiteSpace: 'nowrap',
    minWidth: '12.5%',
    fontSize: '7pt',
    lineHeight: '20px',
    border: '1px solid #DADAE6',
    height: '0px',
    //minWidth: '40px',
  }

  state = {
    customImageBase64: null,
    arrayOfBlobs: [],
    selectedBankAccountId: null, 
    startDate: null, 
    endDate: null,
    transactions: [],
    bankName: null, 
    bankIcon: null, 
    bic: null, 
    iban: null, 
    accountType: null, 
    accountHolderName: null, 
    balance: null
  };

  componentDidMount(){
    const { rentalUnits } = this.props;
    var loaderWhole = document.getElementById('hello-housing-loader');
    loaderWhole.style.display = 'block';
    var loaderBackground = document.getElementById('hh_loader_bg');
    var loader = document.getElementById('hh_loader_spinner');
    loaderBackground.style.background = 'white';
    loaderBackground.style.opacity = '1';
    loader.style.zIndex = '99999';

    let url = new URL(window.location.href);
    const selectedBankAccountId = url.searchParams.get("selectedBankAccountId");
    const startDate = url.searchParams.get("startDate");
    const endDate = url.searchParams.get("endDate");

    const bankName = url.searchParams.get("bankName");
    const bankIcon = url.searchParams.get("bankIcon");
    const bic = url.searchParams.get("bic");
    const iban = url.searchParams.get("iban");
    const accountType = url.searchParams.get("accountType");
    const accountHolderName = url.searchParams.get("accountHolderName");
    const balance = url.searchParams.get("balance");

    console.log('dates: ', startDate, endDate);
    this.setState({selectedBankAccountId, startDate, endDate, bankName, bankIcon, bic, iban, accountType, accountHolderName, balance}, ()=> this.getTransactions());
  }

  getTransactions=()=>{
    const {selectedBankAccountId, startDate, endDate} = this.state;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + 'transactions/search?bankAccountId=' + selectedBankAccountId+`${startDate ? '&fromDateTime=' + `${dayjs(startDate, 'DD.MM.YYYY').format('YYYY-MM-DD')}T00:00:00Z` : ''}${endDate ? '&toDateTime=' + `${dayjs(endDate, 'DD.MM.YYYY').format('YYYY-MM-DD')}T00:00:00Z` : ''}`,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetTransactions',
      null,
      false,
      '',
      {
        // 'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handleGetTransactions(response){
    if(response.status && response.statuscode === 200){
      this.setState({transactions: response.result}, ()=> this.getAccountPicture());
    }else{
      this.getAccountPicture();
    }
  }

  getAccountPicture=()=>{
    fetch(Autoload.Setting.account_api_baseurl + this.props.accountData.accountId +'/picture/download', 
    {
      method: 'GET',
      headers: {
        'Content-Type': 'octet-stream',
        'Authorization': Autoload.Utils.getAuthToken()
      }
    }).then(response => {
      response.blob()
      .then(async blob => {
        const options = {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 400,
          useWebWorker: true
        }
        try {
          let fileNew = new File([blob], "my_image.png",{type:"image/png", lastModified:new Date().getTime()});
          
          const compressedFile = await imageCompression(fileNew, options);
          console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
          console.log(`compressedFile size ${compressedFile.size / 1024} KB`); // smaller than maxSizeMB
          
          var reader = new FileReader();
          reader.readAsDataURL(compressedFile); 

          const setState=(base64)=>{
            this.setState({customImageBase64: base64 ? base64 : null});
          }
          
          reader.onloadend = function() {
            var base64data = reader.result;                
            console.log('base64data: ', base64data);
            setState(base64data);
          }
        } catch (error) {
          console.log('getAccountPicture: ', error);
        }

        setTimeout(() => {
          this.downloadPdfFromServer();
        }, 1000);
      }).catch(e1=> {
        console.log('getAccountPicture: error1: ', e1);
        setTimeout(() => {
          this.downloadPdfFromServer();
        }, 1000);
      })
    }).catch(e=> {
      console.log('getAccountPicture: error: ', e);
      setTimeout(() => {
        this.downloadPdfFromServer();
      }, 1000);
    })
  }


  getTableLabels = () => {
    return (
      <TableRow>
        <TableCell style={this.tableHeadCellStyling}>{'Sender / Empfänger'}</TableCell>
        <TableCell style={this.tableHeadCellStyling}>{'Datum'}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{'Betrag'}</TableCell>
        <TableCell style={this.tableHeadCellStyling}>{'Beschreibung'}</TableCell>
        <TableCell style={this.tableHeadCellStyling}>{'IBAN'}</TableCell>
        {/* <TableCell style={this.tableHeadCellStyling}>{'Betrag'}</TableCell> */}
      </TableRow>
    );
  };

  downloadPdfFromServer=()=>{
    console.log('downloadPdfFromServer:');
    const data = new FormData();
    const closeWindow = ()=> {
        var allowDownloadSafari = document.getElementById('allow_download');
        allowDownloadSafari.style.display = browserName === 'Safari' && 'block'; 
        var spinner = document.getElementById('hh_loader_spinner');
        browserName !== 'Safari' ? loader(false) : spinner.style.display = 'none';
        browserName !== 'Safari' && window.close();
    }
    let html = document.getElementById('divToPrint0');
    let doc = document.implementation.createHTMLDocument("New Document");
    try {
      const {accountData, propertySelected} = this.props;
      doc.body.appendChild(html);
      const blob = new Blob([doc.documentElement.innerHTML], {
        type: 'text/html'
       });
       
      const fileName = `tenantExportPdf-${this.props.propertySelected.name}-${new Date().valueOf()}}`;
      let file = new File([blob], fileName);
      file.originalname = fileName;
      console.log('downloadPdfFromServer: ', file);

      data.append('file', file);
      let footer = `${accountData.addressCompany && (accountData.addressCompany + ', ')}${accountData.addressStreet && (accountData.addressStreet + ',')} ${(accountData.addressZipCode)} ${accountData.addressCity}`;
      console.log('propertySelectedsadfadg: ', propertySelected);
      if(propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled){
        const {propertyOwner} = propertySelected;
        footer = `${propertyOwner?.name && (propertyOwner?.name + ', ')}${propertyOwner?.street && (propertyOwner?.street + ', ')}${(propertyOwner?.postalCode)} ${propertyOwner?.city}`;
        data.append('footer', footer);
      }else{
        data.append('footer', footer);
      }
      let url = `https://${checkEnvironment()}.hellohousing.de/api/reporting-api/pdf`;
      fetch(url,
        {
          method: 'POST',
          body: data,
          headers: {
            Authorization: Autoload.Utils.getAuthToken(),
          }
        }).then((response)=> {
          if(response.status === 200){
            response.blob()
            .then(data => {
              this.convertBlobToArrayBuffer(data).then((value)=> {
                const pdfBytes = this.mergePdfs([value]);
                const propertySelected = this.props.propertySelected;
                pdfBytes.then(function(result) {
                  var blob = new Blob([result], {type: "application/pdf"});
                  var link = document.createElement('a');
                  link.href = window.URL.createObjectURL(blob);
                  //var fileName = reportName;
                  link.download = `${propertySelected?.propertyAddress ? `${propertySelected?.propertyAddress}, ${propertySelected?.propertyZipCode} ${propertySelected?.propertyCity}` : propertySelected.name} ${moment().format('DD.MM.YYYY')}.pdf`;
                  //link.download = 'testing_123.pdf';
                  
                  link.click();
                  
                  setTimeout(() => {
                      closeWindow();
                  }, 500);
              })
              })
  
              //download progress
              // var a = document.createElement("a");
              // document.body.appendChild(a);
              // let url = window.URL.createObjectURL(data);
              // a.href = url;
              // a.download = `Export-Mieteraufstellung-${this.props.propertySelected?.propertyAddress ? `${this.props.propertySelected?.propertyAddress}_${this.props.propertySelected?.propertyZipCode}_${this.props.propertySelected?.propertyCity}` : this.props.propertySelected.name}-${moment().format('YYYYMMDD')}.pdf`;
              // a.click();
              // window.URL.revokeObjectURL(url);
              // setTimeout(() => {
              //   closeWindow();
              // }, 500);
            })
          }else{
            errorHandlingForPDF(response, this.props.profileData, url);
          }
        });
    } catch (e) {
      console.log('downloadPdfFromServer: ', e);
    }
}

async convertBlobToArrayBuffer(blob) {
const buf = await blob.arrayBuffer();
return buf;
}

async mergePdfs(pdfsToMerge) {
console.log('mergePdfs', pdfsToMerge);
const mergedPdf = await PDFDocument.create();
const font = await mergedPdf.embedStandardFont(StandardFonts.Helvetica);

const createInnerPromise = async (arrayBuffer) => {
  const pdf = await PDFDocument.load(arrayBuffer);
  return await mergedPdf.copyPages(pdf, pdf.getPageIndices());
};

const outerPromise = pdfsToMerge.map((arrayBuffer) => {
  const innerPromise = createInnerPromise(arrayBuffer);
  return innerPromise;
});

const resultOuterPromise = await Promise.all(outerPromise);

let count = 0;
let totalPages = 0;
resultOuterPromise.forEach((pageArray, i) => {
  pageArray.forEach((page, index) => {
    totalPages = totalPages + 1;
  })
});
resultOuterPromise.forEach((pageArray, i) => {
  pageArray.forEach((page) => {
    const { width, height } = page.getSize();
    page.drawText(`Seite ${count+1} von ${totalPages}`, {
      x: width - 79,
      y: height - 27,
      size: 6,
      color: rgb(0.5, 0.5, 0.5),
    });
    //add footer
    // var text = `${this.props.accountData.addressCompany && (this.props.accountData.addressCompany + ', ')}${this.props.accountData.addressStreet && (this.props.accountData.addressStreet + ',')} ${(this.props.accountData.addressZipCode)} ${this.props.accountData.addressCity}`;
    // const textWidth = font.widthOfTextAtSize(text, 8);
    // page.drawText(text, {
    //   x: page.getWidth() / 2 - textWidth / 2,
    //   y: height - (height-30),
    //   size: 8,
    //   color: rgb(0.5, 0.5, 0.5)
    // });
    //
    mergedPdf.addPage(page);
    count = count + 1;
  });
});

return (await mergedPdf.save()).buffer;
}

renderTableBody=()=>{
  const {transactions} = this.state;
  return(
    <TableBody>
      {transactions.length > 0 ?
      transactions.map((transaction)=>
      <TableRow>
        <TableCell style={this.tableBodyCellStyling}>{transaction.counterpartName}</TableCell>
        <TableCell style={this.tableBodyCellStyling}>{dayjs(transaction.bankBookingDate).format('DD.MM.YYYY')}</TableCell>
        <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}}>{accounting.formatMoney(transaction.amount, { symbol: "€",  format: "%v %s", precision: 2, thousand: '.', decimal: ',' })}</TableCell>
        <TableCell style={this.tableBodyCellStyling}>{transaction.purpose}</TableCell>
        <TableCell style={this.tableBodyCellStyling}>{transaction.counterpartIban}</TableCell>
      </TableRow>)
      :
      <TableRow>
        <TableCell style={this.tableBodyCellStyling} colSpan={5}>
          <EmptyStateContainer
          heading={'Keine Zahlungen gefunden.'}
          subheading={'Klicken Sie auf Zahlungen aktualisieren, um neue Zahlungen abzurufen.'}
          showBtn={false}
          icon={Bank}
          />
        </TableCell>
      </TableRow>}
    </TableBody>
  )
}

getBankType=(type)=>{
  switch (type) {
    case 'Checking':
      return 'Girokonto';
    case 'Savings':
      return 'Sparkonto';
    case 'CreditCard':
      return 'Kreditkarte';
    case 'Security':
      return 'Bürgschaft';
    case 'Loan':
      return 'Darlehen';
    case 'Membership':
      return 'Mitgliedschaft';
    case 'Bausparen':
      return 'Bausparkonto';
    default:
      return type;
  }
}

render() {
  const { allRents, customImageBase64, startDate, endDate, arrayOfBlobs, bankName, bankIcon, bic, iban, accountType, accountHolderName, balance } = this.state;
  const { rentalUnits, propertySelected, isLogoHidden } = this.props;

  console.log('arrayOfBlobs: ', arrayOfBlobs);

  return (
    <div
    style={{fontFamily: 'Inter,sans-serif'}}
    id={'mainDiv'}>
        <div
          ref={ref}
          id={'divToPrint0'}
          style={{fontFamily: 'Inter,sans-serif', maxWidth: '186mm', width: '100%',}}
        >
          {isLogoHidden === false ?
          <div style={{ marginBottom: 48 }}>
            <img src={this.props.companyLogoEnable === 'UserDefined' ? customImageBase64 !== null ? customImageBase64 : Logo : Logo} id='logo' alt="logo" style={{height: '56px'}}/>
          </div>
          :
          <div style={{ marginBottom: 48 }}/>}
          <div style={{ marginBottom: 38}}>
            <span style={{fontWeight: '500', fontSize: '17pt'}}>{`Kontoauszüge (${startDate} - ${endDate})`}</span>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'start', alignItems: 'flex-start', marginBottom: '22px' }}>
            <div style={{ width: "33.3%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676', fontWeight: 'bold' }}>Bankname</p>
              <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'normal', textOverflow: 'ellipsis' }}>
                {bankName !== 'null' ? bankName : '-'}
              </p>
            </div>
            <div style={{ width: "33.3%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676', fontWeight: 'bold' }}>BIC</p>
              <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'normal', wordBreak: 'break-all', textOverflow: 'ellipsis', width: '85%' }}>
                {bic !== 'null' ? bic : '-'}
              </p>
            </div>
            <div style={{ width: "33.3%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676', fontWeight: 'bold' }}>IBAN</p>
              <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                {iban !== 'null' ? iban : '-'}
              </p>
            </div>
            <div style={{ width: "33.3%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676', fontWeight: 'bold' }}>Art</p>
              <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                {accountType !== 'null' ? this.getBankType(accountType) : '-'}
              </p>
            </div>

            <div style={{ width: "33.3%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676', fontWeight: 'bold' }}>Inhalber</p>
              <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                {accountHolderName !== 'null' ? accountHolderName : '-'}
              </p>
            </div>

            <div style={{ width: "33.3%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676', fontWeight: 'bold' }}>Saldo</p>
              <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                {balance !== 'null' ? accounting.formatMoney(balance, '€', 2, '.', ',', '%v %s') : '-'}
              </p>
            </div>
          </div>
          <TableContainer component={Paper} style={{background: 'transparent'}}>
            <Table style={{borderCollapse: 'collapse', width: '100%'}}>
              <TableHead>
                {this.getTableLabels()}
              </TableHead>
                {this.renderTableBody()}
            </Table>
          </TableContainer>
        </div>
    </div>
  );
}
}

const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
    rentalUnits: state.tenantDataReducer.rentalUnits,
    accountData: state.generalReducer.accountData,
    companyLogoEnable: state.generalReducer.companyLogoEnable,
    selectedTaxYearForTaxDeclaration: state.generalReducer.selectedTaxYearForTaxDeclaration,
    isLogoHidden: state.generalReducer.isLogoHidden,
    profileData: state.generalReducer.profile
  };
};

const actions = {
  setSelectedTaxYearForTaxDeclaration
}
export default connect(mapStateToProps, actions)(TransactionsPdfExport);
